(function () {
  const template = document.body.dataset.template;
  if (
    template !== 'product.home-gym' &&
    template !== 'product.supplement-betterme' &&
    template !== 'product.upsell_bundle_equip' &&
    template !== 'product.equipment_amplify'
  )
    return;

  const isSupplementTemplate = template === 'product.supplement-betterme';
  const SELECTED_ATTR = '_collapsableGroup_selected_';
  const POPULAR_BADGE_CLASS = 'home-gym-popular-badge';
  const STICKY_HIDDEN_CLASS = 'home-gym-sticky-hidden';
  const STICKY_NO_PRICE_CLASS = 'home-gym-sticky-no-price';
  const DESKTOP_BP = '(min-width: 992px)';

  const bundleWidgetSuppressed = () => {
    const widget = document.querySelector('amplify-bundle-breaks-widget');
    return !!widget && getComputedStyle(widget).display === 'none';
  };

  const stickyPriceParts = sticky => {
    const compare = sticky.querySelector(
      '.sticky-regular-price .price-item--regular'
    );
    return {
      sale: sticky.querySelector('.sticky-regular-price .price-item--sale'),
      compare,
      compareParent: compare ? compare.closest('.price__compare') : null,
      line: sticky.querySelector('.sticky-regular-price .line'),
      container: sticky.querySelector('.sticky-regular-price .price'),
      button: sticky.querySelector('#btn-add .equipment.price')
    };
  };

  const captureStickyBaseline = sticky => {
    if (sticky.dataset.homeGymBaseline) return;
    const { sale, compare, compareParent, line, container, button } =
      stickyPriceParts(sticky);
    sticky.dataset.homeGymBaseline = JSON.stringify({
      sale: sale ? sale.textContent : null,
      compare: compare ? compare.textContent : null,
      compareHidden: compare ? compare.classList.contains('hidden') : null,
      compareDisplay: compare ? compare.style.display : null,
      parentHidden: compareParent
        ? compareParent.classList.contains('hidden')
        : null,
      parentDisplay: compareParent ? compareParent.style.display : null,
      lineHidden: line ? line.classList.contains('hidden') : null,
      onSale: container ? container.classList.contains('price--on-sale') : null,
      button: button ? button.innerHTML : null
    });
  };

  const restoreDisplay = (el, value) => {
    if (el === null || value === null) return;
    if (value) el.style.display = value;
    else el.style.removeProperty('display');
  };

  const restoreStickyBaseline = sticky => {
    const raw = sticky.dataset.homeGymBaseline;
    if (!raw) return;
    let base;
    try {
      base = JSON.parse(raw);
    } catch (e) {
      delete sticky.dataset.homeGymBaseline;
      return;
    }
    const { sale, compare, compareParent, line, container, button } =
      stickyPriceParts(sticky);
    if (sale && base.sale !== null && sale.textContent !== base.sale) {
      sale.textContent = base.sale;
    }
    if (compare && base.compare !== null) {
      if (compare.textContent !== base.compare)
        compare.textContent = base.compare;
      compare.classList.toggle('hidden', !!base.compareHidden);
      restoreDisplay(compare, base.compareDisplay);
    }
    if (compareParent && base.parentHidden !== null) {
      compareParent.classList.toggle('hidden', !!base.parentHidden);
      restoreDisplay(compareParent, base.parentDisplay);
    }
    if (line && base.lineHidden !== null) {
      line.classList.toggle('hidden', !!base.lineHidden);
    }
    if (container && base.onSale !== null) {
      container.classList.toggle('price--on-sale', !!base.onSale);
    }
    if (button && base.button !== null && button.innerHTML !== base.button) {
      button.innerHTML = base.button;
      delete button.dataset.bundleKey;
    }
    delete sticky.dataset.homeGymBaseline;
  };

  const activeCurrency = () => window.Shopify?.currency?.active || 'USD';

  const activeLocale = () =>
    document.documentElement.getAttribute('lang') ||
    window.Shopify?.locale ||
    navigator.language ||
    'en';

  const parseAmplifyPrice = text => {
    if (!text) return 0;
    let s = String(text).replace(/[^\d.,]/g, '');
    if (!s) return 0;
    const lastComma = s.lastIndexOf(',');
    const lastDot = s.lastIndexOf('.');
    let decimalSep = '';
    if (lastComma > lastDot) decimalSep = ',';
    else if (lastDot > -1) decimalSep = '.';
    if (decimalSep) {
      const thousandsSep = decimalSep === ',' ? '.' : ',';
      s = s.split(thousandsSep).join('');
      s = s.replace(decimalSep, '.');
    }
    const value = parseFloat(s);
    return Number.isFinite(value) ? Math.round(value * 100) : 0;
  };

  const formatMarket = cents => {
    try {
      return new Intl.NumberFormat(activeLocale(), {
        style: 'currency',
        currency: activeCurrency()
      }).format(cents / 100);
    } catch (e) {}
    try {
      if (typeof window.Shopify?.formatMoney === 'function') {
        return window.Shopify.formatMoney(
          cents,
          window.Shopify?.money_format || '${{amount}}'
        );
      }
    } catch (e) {}
    return `$${(cents / 100).toFixed(2)}`;
  };

  const formatCents = cents => formatMarket(cents);

  const formatMoneyLike = (cents, sample) => {
    const whole = cents % 100 === 0;
    const decMatch = sample && String(sample).match(/[.,](\d{2})(?!\d)/);
    const decSep = decMatch ? String(sample)[decMatch.index] : '.';
    const thouSep = decSep === ',' ? '.' : ',';
    const intStr = Math.floor(Math.abs(cents) / 100)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, thouSep);
    const num = whole
      ? intStr
      : `${intStr}${decSep}${String(Math.abs(cents) % 100).padStart(2, '0')}`;
    if (sample && /\d/.test(sample)) {
      return String(sample).replace(/\d[\d.,\s]*\d|\d/, num);
    }
    return num;
  };

  const isMoneyText = txt =>
    !!txt && /\d/.test(txt) && /[\d][.,]?\d?/.test(txt);

  const getProductData = () => window.amplifyAppBlockJsonData?.products || null;

  const findVariant = (productId, variantId) => {
    const products = getProductData();
    if (!products) return null;
    const product = products[productId];
    if (!product || !Array.isArray(product.variants)) return null;
    return (
      product.variants.find(v => String(v.id) === String(variantId)) ||
      product.variants[0]
    );
  };

  const imageFileKey = url => {
    if (!url) return '';
    const m = String(url).match(/\/(?:files|products)\/([^/?#]+)/i);
    return m ? m[1].toLowerCase() : '';
  };

  const normTitle = t => (t || '').trim().toLowerCase();

  let __homeGymOosFpCache = null;
  let __homeGymOosFpProducts = null;
  const getOosFingerprints = () => {
    const products = getProductData();
    if (__homeGymOosFpCache && __homeGymOosFpProducts === products) {
      return __homeGymOosFpCache;
    }
    const fp = { files: new Set(), titles: new Set() };
    if (!products) return fp;
    Object.values(products).forEach(p => {
      if (!p) return;
      const variants = Array.isArray(p.variants) ? p.variants : [];
      const allVariantsOos =
        variants.length > 0 &&
        variants.every(v => v && v.availableForSale === false);
      const productOos = p.availableForSale === false || allVariantsOos;
      if (!productOos) return;
      if (p.title) fp.titles.add(normTitle(p.title));
      const srcs = [p.imageSrc, ...(p.images || []).map(i => i && i.src)];
      srcs.forEach(s => {
        const key = imageFileKey(s);
        if (key) fp.files.add(key);
      });
    });
    __homeGymOosFpCache = fp;
    __homeGymOosFpProducts = products;
    return fp;
  };

  const bundleHasOosProduct = (item, fp) => {
    if (!fp || (!fp.files.size && !fp.titles.size)) return false;
    const cards = item.querySelectorAll('.picky-product-card');
    for (const card of cards) {
      const img = card.querySelector('img');
      const key = imageFileKey(img && (img.currentSrc || img.src));
      if (key && fp.files.has(key)) return true;
      const titleEl = card.querySelector('.picky-product-card__title');
      if (titleEl && fp.titles.has(normTitle(titleEl.textContent))) return true;
    }
    return false;
  };

  const injectSaveBadges = () => {
    document.querySelectorAll('.picky-bundle-breaks__item').forEach(item => {
      const compareEl = item.querySelector(
        '.picky-qb-offer-item__compare-at-price'
      );
      const priceEl = item.querySelector('.picky-qb-offer-item__price');
      const pricesWrapper = item.querySelector(
        '.picky-qb-offer-item__prices-wrapper'
      );
      if (!compareEl || !priceEl || !pricesWrapper) {
        pricesWrapper?.querySelector('.home-gym-save-badge-row')?.remove();
        return;
      }
      const savingsCents =
        parseAmplifyPrice(compareEl.textContent.trim()) -
        parseAmplifyPrice(priceEl.textContent.trim());
      if (savingsCents <= 0) {
        pricesWrapper.querySelector('.home-gym-save-badge-row')?.remove();
        return;
      }
      const desiredText = `Save ${formatMoneyLike(
        savingsCents,
        priceEl.textContent.trim()
      )}`;
      let row = pricesWrapper.querySelector('.home-gym-save-badge-row');
      if (!row) {
        row = document.createElement('div');
        row.className = 'home-gym-save-badge-row';
        const pill = document.createElement('span');
        pill.className = 'home-gym-save-badge';
        pill.textContent = desiredText;
        row.appendChild(pill);
        pricesWrapper.appendChild(row);
        return;
      }
      const pill = row.querySelector('.home-gym-save-badge');
      if (pill && pill.textContent !== desiredText) {
        pill.textContent = desiredText;
      }
    });
  };

  const priceNodesOf = card =>
    Array.from(
      card.querySelectorAll(
        '[class*="price" i], [class*="Price"], [class*="_money_" i], [class*="money" i]'
      )
    ).filter(n => {
      if (n.closest('.home-gym-card-price')) return false;
      return isMoneyText(n.textContent.trim()) && n.children.length <= 2;
    });

  const cardPriceSignature = card =>
    `${priceNodesOf(card)
      .map(n => n.textContent.trim())
      .join('|')}#${card.dataset.selectedVariantId || ''}#${
      card.dataset.productId || ''
    }`;

  const readCardPrices = card => {
    const priceNodes = priceNodesOf(card);

    let saleText = '';
    let compareText = '';
    priceNodes.forEach(node => {
      const cls = String(node.className || '');
      const txt = node.textContent.trim();
      if (!isMoneyText(txt)) return;
      const isCompare =
        /compare|original|old|strike|regular|was|crossed/i.test(cls) ||
        /line-through/.test(getComputedStyle(node).textDecorationLine || '');
      if (isCompare) {
        if (!compareText) compareText = txt;
      } else if (!saleText) {
        saleText = txt;
      }
    });

    if (saleText) return { saleText, compareText, source: 'amplify' };

    const variant = findVariant(
      card.dataset.productId,
      card.dataset.selectedVariantId
    );
    if (!variant) return null;
    const hasCompare =
      variant.compareAtPrice && variant.compareAtPrice > variant.price;
    return {
      saleText: formatCents(variant.price),
      compareText: hasCompare ? formatCents(variant.compareAtPrice) : '',
      source: 'data'
    };
  };

  const injectProductPrices = () => {
    document.querySelectorAll('.picky-product-card').forEach(card => {
      const sig = cardPriceSignature(card);
      if (card.dataset.homeGymPriceSig === sig) return;
      const prices = readCardPrices(card);
      if (!prices) return;
      card.dataset.homeGymPriceSig = sig;
      const info = card.querySelector('[class*="_info_"]');
      if (!info) return;
      const { saleText, compareText } = prices;
      const desiredKey = `${saleText}|${compareText}`;

      let priceEl = info.querySelector('.home-gym-card-price');
      if (priceEl && priceEl.dataset.key === desiredKey) return;

      if (!priceEl) {
        priceEl = document.createElement('div');
        priceEl.className = 'home-gym-card-price';
        const title = info.querySelector('.picky-product-card__title');
        if (title && title.nextSibling) {
          info.insertBefore(priceEl, title.nextSibling);
        } else {
          info.appendChild(priceEl);
        }
      }
      priceEl.dataset.key = desiredKey;
      priceEl.textContent = '';
      const saleSpan = document.createElement('span');
      saleSpan.className = 'home-gym-card-price__sale';
      saleSpan.textContent = saleText;
      priceEl.appendChild(saleSpan);
      if (compareText) {
        const compareSpan = document.createElement('span');
        compareSpan.className = 'home-gym-card-price__compare';
        compareSpan.textContent = compareText;
        priceEl.appendChild(compareSpan);
      }
    });
  };

  const applyPopularBadge = () => {
    document.querySelectorAll('.picky-bundle-breaks__badge').forEach(badge => {
      const isPopular = /MOST POPULAR/i.test(badge.textContent);
      const hasClass = badge.classList.contains(POPULAR_BADGE_CLASS);
      if (isPopular === hasClass) return;
      badge.classList.toggle(POPULAR_BADGE_CLASS, isPopular);
    });
  };

  const getMainComparePair = () => {
    const scope =
      document.querySelector('.product__info-header') ||
      document.querySelector('.product__info-container') ||
      document;
    const saleEl = scope.querySelector(
      '.selling .price-item--sale, .price .price-item--sale, .price-item--sale'
    );
    const compareEl = scope.querySelector(
      '.selling .price-item--regular, .price .price-item--regular, .price-item--regular'
    );
    return {
      sale: saleEl ? saleEl.textContent.trim() : '',
      compare: compareEl ? compareEl.textContent.trim() : ''
    };
  };

  const injectBasicCompareAt = () => {
    const { compare, sale } = getMainComparePair();
    if (!compare || compare === sale) return;
    let soloHandled = false;
    document.querySelectorAll('.picky-bundle-breaks__item').forEach(item => {
      const wrapper = item.querySelector(
        '.picky-qb-offer-item__prices-wrapper'
      );
      const priceEl = item.querySelector('.picky-qb-offer-item__price');
      const pickyCompare = item.querySelector(
        '.picky-qb-offer-item__compare-at-price'
      );
      if (!wrapper || !priceEl) return;
      if (pickyCompare) return;
      if (soloHandled) return;
      soloHandled = true;
      let el = wrapper.querySelector('.home-gym-basic-compare');
      if (!el) {
        el = document.createElement('span');
        el.className = 'home-gym-basic-compare';
        wrapper.insertBefore(el, priceEl);
      }
      if (el.textContent !== compare) el.textContent = compare;
    });
  };

  const getBundleWidgetRoot = () =>
    document.querySelector('amplify-bundle-breaks-widget') ||
    document.querySelector('.picky-widget.picky-bundle-breaks');

  const getSelectedItem = () => {
    const scope = getBundleWidgetRoot() || document;
    return scope.querySelector(
      `.picky-bundle-breaks__item[class*="${SELECTED_ATTR}"]`
    );
  };

  const getSelectedTierIndex = () => {
    const selected = getSelectedItem();
    if (!selected) return null;
    const widget =
      selected.closest('.picky-widget.picky-bundle-breaks') ||
      selected.closest('amplify-bundle-breaks-widget');
    if (!widget) return null;
    const items = Array.from(
      widget.querySelectorAll('.picky-bundle-breaks__item')
    );
    const index = items.indexOf(selected);
    return index === -1 ? null : index + 1;
  };
  const pushBundleEvent = (eventName, params) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'custom_event',
      event_name: eventName,
      parameter: JSON.stringify(params)
    });
  };

  const getAtcSuffix = button =>
    button?.matches?.('#btn-add') ? 'quick_add' : 'main';

  const trackAtcAnalytics = button => {
    const waitForLoad =
      typeof waitForProductPageLoad === 'function'
        ? waitForProductPageLoad
        : () => Promise.resolve();

    waitForLoad().then(() => {
      window.setTimeout(() => {
        if (isSoloSelected()) {
          if (typeof handleAddToCartEvent === 'function') {
            handleAddToCartEvent(getAtcSuffix(button));
          }
        } else {
          const tier = getSelectedTierIndex();
          if (
            tier != null &&
            typeof pushAmplifyBundleAddToCart === 'function'
          ) {
            pushAmplifyBundleAddToCart(tier);
          }
        }

        if (
          document.body.classList.contains('tw-b2b') &&
          typeof addToCartQuantityB2BEvent === 'function'
        ) {
          addToCartQuantityB2BEvent();
        }
      }, 50);
    });
  };

  const OOS_CLASS_RE =
    /(_outOfStock_|outofstock|out-of-stock|_soldOut_|soldout|sold-out|unavailable|_notAvailable)/i;

  const elHasOosClass = el => {
    const cls = el && typeof el.className === 'string' ? el.className : '';
    return OOS_CLASS_RE.test(cls);
  };

  const getBundleTitle = item =>
    normTitle(
      item.querySelector('[class*="_name_"], .picky-qb-offer-item__title')
        ?.textContent
    );

  const isBundleOutOfStock = (item, fp) => {
    const title = getBundleTitle(item);
    if (title && window.__homeGymOosTitles?.has(title)) return true;

    if (bundleHasOosProduct(item, fp)) return true;

    if (item.getAttribute('aria-disabled') === 'true') return true;

    if (
      item.querySelector(
        '[role="button"][aria-disabled="true"], button[disabled], [data-option-value-is-available="false"]'
      )
    ) {
      return true;
    }

    if (elHasOosClass(item)) return true;
    if (Array.from(item.querySelectorAll('*')).some(elHasOosClass)) return true;

    return false;
  };

  const rememberOosTitle = item => {
    const title = getBundleTitle(item);
    if (!title) return;
    if (!window.__homeGymOosTitles) window.__homeGymOosTitles = new Set();
    window.__homeGymOosTitles.add(title);
  };

  const enforceOosHidden = () => {
    const titles = window.__homeGymOosTitles;
    if (!titles || !titles.size) return;
    document.querySelectorAll('.picky-bundle-breaks__item').forEach(item => {
      const title = getBundleTitle(item);
      if (!title || !titles.has(title)) return;
      if (item.style.display !== 'none') {
        item.style.setProperty('display', 'none', 'important');
      }
      if (!item.classList.contains('home-gym-bundle-hidden')) {
        item.classList.add('home-gym-bundle-hidden');
      }
      if (item.dataset.homeGymOos !== '1') item.dataset.homeGymOos = '1';
    });
  };

  const readBundlePriceInfo = item => {
    const priceEl = item.querySelector('.picky-qb-offer-item__price');
    const compareEl = item.querySelector(
      '.picky-qb-offer-item__compare-at-price'
    );
    const priceCents = priceEl ? parseAmplifyPrice(priceEl.textContent) : 0;
    const hasCompare = !!(
      compareEl && isMoneyText(compareEl.textContent.trim())
    );
    return { priceCents, hasCompare };
  };

  const computeDegenerateOos = items => {
    const degenerate = new Set();
    let soloCents = null;
    items.forEach(item => {
      const { priceCents, hasCompare } = readBundlePriceInfo(item);
      if (hasCompare || priceCents <= 0) return;
      if (soloCents === null) {
        soloCents = priceCents;
        return;
      }
      if (priceCents === soloCents) degenerate.add(item);
    });
    return degenerate;
  };

  const hideOutOfStockBundles = () => {
    const fp = getOosFingerprints();
    const items = Array.from(
      document.querySelectorAll('.picky-bundle-breaks__item')
    );
    const degenerate = computeDegenerateOos(items);
    let firstAvailable = null;
    items.forEach(item => {
      const oos = degenerate.has(item) || isBundleOutOfStock(item, fp);
      const wasHidden = item.dataset.homeGymOos === '1';
      if (oos) {
        rememberOosTitle(item);
        item.classList.add('home-gym-bundle-hidden');
        item.style.setProperty('display', 'none', 'important');
        item.dataset.homeGymOos = '1';
      } else {
        if (wasHidden) {
          item.classList.remove('home-gym-bundle-hidden');
          item.style.removeProperty('display');
          delete item.dataset.homeGymOos;
        }
        if (!firstAvailable) firstAvailable = item;
      }
    });
    const selected = getSelectedItem();
    const selectedHidden = selected && selected.dataset.homeGymOos === '1';
    const recentlySwitched =
      Date.now() - (window.__homeGymAutoSwitchAt || 0) < 1500;
    if (selectedHidden && firstAvailable && !recentlySwitched) {
      window.__homeGymAutoSwitchAt = Date.now();
      const clickTarget =
        firstAvailable.querySelector('input[type="radio"], [role="radio"]') ||
        firstAvailable.querySelector('[class*="_head_"]') ||
        firstAvailable.querySelector(
          '[role="button"]:not([aria-disabled="true"])'
        ) ||
        firstAvailable;
      try {
        clickTarget?.click();
      } catch (e) {}
    }
  };

  const isBundleItemHidden = item =>
    item.dataset.homeGymOos === '1' ||
    item.classList.contains('home-gym-bundle-hidden') ||
    item.style.display === 'none';

  const syncBundleSaveTitle = () => {
    if (!isSupplementTemplate) return;
    const title = document.querySelector('[data-home-gym-bundle-save-title]');
    if (!title) return;

    const amplify = document.querySelector(
      '[data-amplify="bundle-breaks-widget"]'
    );
    const hasVisibleItems = amplify
      ? Array.from(amplify.querySelectorAll('.picky-bundle-breaks__item')).some(
          item => !isBundleItemHidden(item)
        )
      : false;

    title.classList.toggle('tw-hidden', !hasVisibleItems);
  };

  const getPopularItem = () => {
    const badge = document.querySelector(
      '.picky-bundle-breaks__badge.home-gym-popular-badge'
    );
    const fromClass = badge?.closest('.picky-bundle-breaks__item');
    if (fromClass) return fromClass;
    const badges = document.querySelectorAll('.picky-bundle-breaks__badge');
    for (const b of badges) {
      if (/MOST POPULAR/i.test(b.textContent)) {
        const item = b.closest('.picky-bundle-breaks__item');
        if (item) return item;
      }
    }
    return null;
  };

  const ensureBundleSelected = () => {
    const items = Array.from(
      document.querySelectorAll('.picky-bundle-breaks__item')
    );
    if (!items.length) return;
    const visible = items.filter(item => !isBundleItemHidden(item));
    if (!visible.length) return;
    const selected = getSelectedItem();
    if (selected && !isBundleItemHidden(selected)) return;
    if (Date.now() - (window.__homeGymEnsureSelectAt || 0) < 700) return;
    window.__homeGymEnsureSelectAt = Date.now();
    const popular = getPopularItem();
    const target =
      popular && !isBundleItemHidden(popular) ? popular : visible[0];
    const clickTarget =
      target.querySelector('input[type="radio"], [role="radio"]') ||
      target.querySelector('[class*="_head_"]') ||
      target.querySelector('[role="button"]:not([aria-disabled="true"])') ||
      target;
    try {
      clickTarget?.click();
    } catch (e) {}
  };

  const updateStickyProductName = () => {
    const sticky = document.querySelector('.sticky-quick-add');
    if (!sticky) return;
    const valueEl = sticky.querySelector(
      '.product-info > .product-info__value'
    );
    if (!valueEl) return;

    if (bundleWidgetSuppressed()) {
      const restored = valueEl.dataset.homeGymBaseTitle;
      if (restored && valueEl.textContent.trim() !== restored) {
        valueEl.textContent = restored;
      }
      return;
    }

    if (!window.matchMedia(DESKTOP_BP).matches) return;

    if (!valueEl.dataset.homeGymBaseTitle) {
      valueEl.dataset.homeGymBaseTitle = valueEl.textContent.trim();
    }
    const baseTitle = valueEl.dataset.homeGymBaseTitle;

    const selected = getSelectedItem();
    if (!selected) {
      if (valueEl.textContent.trim() !== baseTitle) {
        valueEl.textContent = baseTitle;
      }
      return;
    }

    const titles = Array.from(
      selected.querySelectorAll('.picky-product-card__title')
    )
      .map(t => t.textContent.trim())
      .filter(Boolean);

    const desired =
      titles.length > 1 ? `${baseTitle} (${titles.join(', ')})` : baseTitle;
    if (valueEl.textContent.trim() !== desired) {
      valueEl.textContent = desired;
    }
  };

  const hasScrolledPastBundles = () => {
    const widget = document.querySelector('.picky-widget.picky-bundle-breaks');
    if (!widget) return true;
    return widget.getBoundingClientRect().bottom <= 0;
  };

  const updateStickyVisibility = () => {
    const sticky = document.querySelector('.sticky-quick-add');
    if (!sticky) return;
    const isDesktop = window.matchMedia(DESKTOP_BP).matches;
    const passed = hasScrolledPastBundles();
    if (isDesktop) {
      sticky.classList.toggle(STICKY_HIDDEN_CLASS, !passed);
      sticky.classList.remove(STICKY_NO_PRICE_CLASS);
    } else {
      sticky.classList.remove(STICKY_HIDDEN_CLASS);
      sticky.classList.toggle(STICKY_NO_PRICE_CLASS, !passed);
    }
  };

  const updateMobileButtonPrice = (sticky, saleFormatted, compareFormatted) => {
    const equipmentPrice = sticky.querySelector('#btn-add .equipment.price');
    if (!equipmentPrice) return;

    const desiredKey = `${saleFormatted}|${compareFormatted}`;
    if (equipmentPrice.dataset.bundleKey === desiredKey) return;

    const compareHtml = compareFormatted
      ? `<span style="font-weight: 500;"><span style="margin: 0 4px;">/</span><span style="text-decoration: line-through; color: gray;">${compareFormatted}</span></span>`
      : '';
    equipmentPrice.innerHTML = `- <span>${saleFormatted}</span>${compareHtml}`;
    equipmentPrice.dataset.bundleKey = desiredKey;
  };

  const updateStickyPrice = () => {
    const sticky = document.querySelector('.sticky-quick-add');
    if (!sticky) return;

    if (bundleWidgetSuppressed()) {
      restoreStickyBaseline(sticky);
      return;
    }

    const selected = getSelectedItem();
    if (!selected) return;

    const priceEl = selected.querySelector('.picky-qb-offer-item__price');
    const compareEl = selected.querySelector(
      '.picky-qb-offer-item__compare-at-price'
    );
    if (!priceEl) return;

    const saleFormatted = priceEl.textContent.trim();
    let compareFormatted = compareEl ? compareEl.textContent.trim() : '';
    if (!compareFormatted) {
      const injected = selected.querySelector('.home-gym-basic-compare');
      if (injected && isMoneyText(injected.textContent)) {
        compareFormatted = injected.textContent.trim();
      }
    }

    captureStickyBaseline(sticky);

    const salePriceEl = sticky.querySelector(
      '.sticky-regular-price .price-item--sale'
    );
    const comparePriceEl = sticky.querySelector(
      '.sticky-regular-price .price-item--regular'
    );
    const priceContainer = sticky.querySelector('.sticky-regular-price .price');

    if (salePriceEl && salePriceEl.textContent !== saleFormatted) {
      salePriceEl.textContent = saleFormatted;
    }

    if (comparePriceEl) {
      if (compareFormatted) {
        if (comparePriceEl.textContent !== compareFormatted) {
          comparePriceEl.textContent = compareFormatted;
        }
        comparePriceEl.classList.remove('hidden');
        comparePriceEl.style.removeProperty('display');
        const parentDd = comparePriceEl.closest('.price__compare');
        if (parentDd) {
          parentDd.classList.remove('hidden');
          parentDd.style.removeProperty('display');
        }
        const line = sticky.querySelector('.sticky-regular-price .line');
        line?.classList.remove('hidden');
      } else {
        comparePriceEl.classList.add('hidden');
      }
    }

    if (priceContainer) {
      const hasClass = priceContainer.classList.contains('price--on-sale');
      if (compareFormatted && !hasClass) {
        priceContainer.classList.add('price--on-sale');
      } else if (!compareFormatted && hasClass) {
        priceContainer.classList.remove('price--on-sale');
      }
    }

    updateMobileButtonPrice(sticky, saleFormatted, compareFormatted);
  };

  const setupATCLoader = () => {
    document
      .querySelectorAll('button[data-amplify-bundle-atc-button]')
      .forEach(btn => {
        if (btn.dataset.homeGymLoaderBound === '1') return;
        btn.dataset.homeGymLoaderBound = '1';
        btn.addEventListener(
          'click',
          function (evt) {
            if (btn.disabled) {
              evt.preventDefault();
              evt.stopImmediatePropagation();
              return;
            }
            if (btn.classList.contains('loading')) {
              if (btn.dataset.homeGymLoaderActive === '1') {
                evt.preventDefault();
                evt.stopImmediatePropagation();
              }
              return;
            }
            btn.dataset.homeGymLoaderActive = '1';
            btn.classList.add('loading');
            const text = btn.querySelector('.text');
            const spinner = btn.querySelector('.loading-overlay__spinner');
            text?.classList.add('hidden');
            spinner?.classList.remove('hidden');
            setTimeout(() => {
              btn.dataset.homeGymLoaderActive = '';
              btn.classList.remove('loading');
              btn.querySelector('.text')?.classList.remove('hidden');
              btn
                .querySelector('.loading-overlay__spinner')
                ?.classList.add('hidden');
            }, 6000);
          },
          true
        );
      });
  };

  const isSoloSelected = () => {
    const selected = getSelectedItem();
    if (!selected) return false;
    const cards = selected.querySelectorAll('.picky-product-card');
    return cards.length === 1;
  };

  const getSoloVariantId = () => {
    const form = document.querySelector('form[data-type="add-to-cart-form"]');
    const idInput = form?.querySelector('input[name="id"]');
    if (idInput && idInput.value) return idInput.value;
    const selected = getSelectedItem();
    const card = selected?.querySelector('.picky-product-card');
    return card?.dataset.selectedVariantId || null;
  };

  const updateCheckoutTotals = cart => {
    if (!cart || typeof cart.total_price !== 'number') return;
    try {
      const total = formatCents(cart.total_price);
      document
        .querySelectorAll(
          '.checkout_btn .total_price.money, .subtotal_price .total_price.money'
        )
        .forEach(el => {
          if (el.textContent.trim() !== total) el.textContent = total;
        });
    } catch (e) {}
  };

  let __homeGymSyncTimer = null;
  const syncCheckoutTotal = () => {
    fetch('/cart.js', { cache: 'no-store' })
      .then(r => r.json())
      .then(cart => updateCheckoutTotals(cart))
      .catch(() => {});
  };
  const scheduleCheckoutSync = () => {
    clearTimeout(__homeGymSyncTimer);
    __homeGymSyncTimer = setTimeout(syncCheckoutTotal, 250);
  };

  let __homeGymCartRefreshTimer = null;
  const refreshSlideCart = async () => {
    try {
      const drawer = document.querySelector('slide-cart-drawer');
      if (drawer) drawer._isContentFresh = false;
      if (typeof window.fetchCart === 'function') {
        const cart = await window.fetchCart();
        updateCheckoutTotals(cart);
      } else if (typeof window.bundleSlideCart === 'function') {
        window.bundleSlideCart();
      } else {
        drawer?.refresh?.();
      }
    } catch (e) {}
  };
  const notifyCartAdded = source => {
    const drawer = document.querySelector('slide-cart-drawer');
    if (drawer) drawer._isContentFresh = false;
    document.dispatchEvent(
      new CustomEvent('cart:added', { detail: { source } })
    );
    clearTimeout(__homeGymCartRefreshTimer);
    __homeGymCartRefreshTimer = setTimeout(refreshSlideCart, 500);
    setTimeout(syncCheckoutTotal, 1200);
    setTimeout(syncCheckoutTotal, 2200);
  };

  const handleSoloAdd = async btn => {
    const variantId = getSoloVariantId();
    if (!variantId) return false;
    if (btn) {
      btn.dataset.homeGymLoaderActive = '1';
      btn.classList.add('loading');
      btn.querySelector('.text')?.classList.add('hidden');
      btn
        .querySelector('.loading-overlay__spinner')
        ?.classList.remove('hidden');
    }
    window.__homeGymRecentCartAdd = Date.now();
    window.__homeGymManagedAddAt = Date.now();
    try {
      if (typeof window.addToCart === 'function') {
        const res = await window.addToCart([
          { id: Number(variantId), quantity: 1 }
        ]);
        window.__homeGymManagedAddAt = Date.now();
        if (res === false) return false;
        if (res) {
          if (typeof window.fetchCart === 'function') {
            const cart = await window.fetchCart(
              res.sections?.['slide-cart-fragment']
            );
            updateCheckoutTotals(cart);
          }
          document.dispatchEvent(
            new CustomEvent('cart:added', {
              detail: { source: 'home-gym-solo' }
            })
          );
          setTimeout(syncCheckoutTotal, 1200);
          setTimeout(syncCheckoutTotal, 2200);
          return true;
        }
      }
      const addUrl = `${window.routes.cart_add_url}.js`;
      // Shared transport — see assets/add-to-cart.js.
      const res = await (window.cartAddFetch || fetch)(addUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: 1 }]
        })
      });
      window.__homeGymManagedAddAt = Date.now();
      if (!res.ok) throw new Error('add failed');
      // Amplify's fabricated interception payload (see assets/add-to-cart.js) is
      // a 200 with no real cart mutation behind it.
      const addJson = await res.json().catch(() => null);
      if (window.isCartAddIntercepted?.(addJson))
        throw new Error('add intercepted');
      notifyCartAdded('home-gym-solo');
      return true;
    } catch (e) {
      return false;
    } finally {
      if (btn) {
        setTimeout(() => {
          btn.dataset.homeGymLoaderActive = '';
          btn.classList.remove('loading');
          btn.querySelector('.text')?.classList.remove('hidden');
          btn
            .querySelector('.loading-overlay__spinner')
            ?.classList.add('hidden');
        }, 800);
      }
    }
  };

  const setupBundleBlockClickAnalytics = () => {
    if (window.__homeGymBundleBlockClickInstalled) return;
    window.__homeGymBundleBlockClickInstalled = true;

    let pendingTierItem = null;
    let bundleClickObserver = null;

    const isTierSelected = item =>
      Boolean(
        item &&
        Array.from(item.classList).some(className =>
          className.includes(SELECTED_ATTR)
        )
      );

    const syncBundleBlockClick = () => {
      if (!pendingTierItem) return;

      const candidate = pendingTierItem;
      if (!isTierSelected(candidate)) return;

      pendingTierItem = null;

      const widget =
        candidate.closest('.picky-widget.picky-bundle-breaks') ||
        candidate.closest('amplify-bundle-breaks-widget');
      if (!widget) return;

      const items = Array.from(
        widget.querySelectorAll('.picky-bundle-breaks__item')
      );
      const index = items.indexOf(candidate);
      const tier = index === -1 ? null : index + 1;
      if (tier == null) return;

      pushBundleEvent('bundle_block_click', { tier });
    };

    const attachBundleClickObserver = () => {
      if (bundleClickObserver) return true;

      const widget = getBundleWidgetRoot();
      if (!widget) return false;

      bundleClickObserver = new MutationObserver(syncBundleBlockClick);
      bundleClickObserver.observe(widget, {
        subtree: true,
        attributes: true,
        attributeFilter: ['class']
      });
      return true;
    };

    if (!attachBundleClickObserver()) {
      let attempts = 0;
      const waitForWidget = setInterval(() => {
        attempts += 1;
        if (attachBundleClickObserver() || attempts >= 30) {
          clearInterval(waitForWidget);
        }
      }, 500);
    }

    document.addEventListener(
      'pointerdown',
      e => {
        if (!e.isTrusted) return;

        const widget = getBundleWidgetRoot();
        if (!widget) return;

        const item = e.target.closest('.picky-bundle-breaks__item');
        if (!item || !widget.contains(item)) return;
        if (e.target.closest('.picky-bnd-pdp')) return;
        if (e.target.closest('.picky-option')) return;
        if (e.target.closest('.amplify-bundle-breaks-widget__dropdown-list')) {
          return;
        }

        if (isTierSelected(item)) {
          pendingTierItem = null;
          return;
        }

        pendingTierItem = item;
      },
      true
    );
  };

  const setupSoloAddInterceptor = () => {
    if (window.__homeGymSoloInterceptorInstalled) return;
    window.__homeGymSoloInterceptorInstalled = true;

    document.addEventListener(
      'click',
      e => {
        if (!e.isTrusted) return;

        const btn = e.target.closest(
          'button[data-amplify-bundle-atc-button], .sticky-quick-add #btn-add, .picky-theme-atc-wrapper #btn-add'
        );
        if (!btn) return;
        if (
          btn.classList.contains('notify') ||
          btn.disabled ||
          btn.getAttribute('aria-disabled') === 'true'
        ) {
          return;
        }
        if (!isSoloSelected()) {
          trackAtcAnalytics(btn);
          return;
        }

        trackAtcAnalytics(btn);

        e.preventDefault();
        e.stopImmediatePropagation();
        handleSoloAdd(btn);
      },
      true
    );
  };

  const setupCartInterceptor = () => {
    if (window.__homeGymCartInterceptorInstalled) return;
    window.__homeGymCartInterceptorInstalled = true;

    const handleCartMutation = (source, isAdd) => {
      const managedRecently =
        Date.now() - (window.__homeGymManagedAddAt || 0) < 2000;
      if (managedRecently) return;
      if (isAdd) {
        notifyCartAdded(source);
        return;
      }
      const drawer = document.querySelector('slide-cart-drawer');
      if (drawer) drawer._isContentFresh = false;
      clearTimeout(__homeGymCartRefreshTimer);
      __homeGymCartRefreshTimer = setTimeout(refreshSlideCart, 500);
      setTimeout(syncCheckoutTotal, 1200);
      setTimeout(syncCheckoutTotal, 2200);
    };

    const isCartMutation = url =>
      /\/cart\/(add|change|update|clear)(?:\.js)?(?:\?|$)/.test(url || '');
    const isCartAdd = url => /\/cart\/add(?:\.js)?(?:\?|$)/.test(url || '');

    const origFetch = window.fetch;
    window.fetch = function (input, init) {
      const url =
        typeof input === 'string' ? input : input && input.url ? input.url : '';
      const result = origFetch.apply(this, arguments);
      if (isCartMutation(url)) {
        Promise.resolve(result)
          .then(res => {
            if (res && (res.ok || res.status === 200)) {
              const add = isCartAdd(url);
              if (add) window.__homeGymRecentCartAdd = Date.now();
              setTimeout(
                () => handleCartMutation('home-gym-cart-fetch', add),
                150
              );
            }
          })
          .catch(() => {});
      }
      return result;
    };

    const origXhrOpen = XMLHttpRequest.prototype.open;
    const origXhrSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__homeGymUrl = url;
      return origXhrOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      if (isCartMutation(this.__homeGymUrl)) {
        this.addEventListener('load', () => {
          if (this.status >= 200 && this.status < 300) {
            const add = isCartAdd(this.__homeGymUrl);
            if (add) window.__homeGymRecentCartAdd = Date.now();
            setTimeout(() => handleCartMutation('home-gym-cart-xhr', add), 150);
          }
        });
      }
      return origXhrSend.apply(this, arguments);
    };

    try {
      const desc = Object.getOwnPropertyDescriptor(Location.prototype, 'href');
      if (desc && typeof desc.set === 'function') {
        const origSet = desc.set;
        const isCartRoute = url => {
          if (!url || typeof url !== 'string') return false;
          return /(?:^|\/)cart(?:\/(?:\?|$)|\?|$)/.test(url);
        };
        Object.defineProperty(Location.prototype, 'href', {
          configurable: true,
          enumerable: desc.enumerable,
          get: desc.get,
          set(url) {
            const recent =
              Date.now() - (window.__homeGymRecentCartAdd || 0) < 2500;
            if (recent && isCartRoute(url)) {
              notifyCartAdded('home-gym-prevent-redirect');
              return;
            }
            return origSet.call(this, url);
          }
        });
      }
    } catch (e) {}

    try {
      const origAssign = Location.prototype.assign;
      const origReplace = Location.prototype.replace;
      Location.prototype.assign = function (url) {
        const recent = Date.now() - (window.__homeGymRecentCartAdd || 0) < 2500;
        if (recent && /(?:^|\/)cart(?:\/(?:\?|$)|\?|$)/.test(url)) {
          notifyCartAdded('home-gym-prevent-assign');
          return;
        }
        return origAssign.apply(this, arguments);
      };
      Location.prototype.replace = function (url) {
        const recent = Date.now() - (window.__homeGymRecentCartAdd || 0) < 2500;
        if (recent && /(?:^|\/)cart(?:\/(?:\?|$)|\?|$)/.test(url)) {
          notifyCartAdded('home-gym-prevent-replace');
          return;
        }
        return origReplace.apply(this, arguments);
      };
    } catch (e) {}
  };

  const runAll = () => {
    try {
      enforceOosHidden();
    } catch (e) {}
    try {
      hideOutOfStockBundles();
    } catch (e) {}
    try {
      ensureBundleSelected();
    } catch (e) {}
    try {
      updateStickyPrice();
    } catch (e) {}
    try {
      injectSaveBadges();
    } catch (e) {}
    try {
      injectProductPrices();
    } catch (e) {}
    try {
      injectBasicCompareAt();
    } catch (e) {}
    try {
      applyPopularBadge();
    } catch (e) {}
    try {
      updateStickyProductName();
    } catch (e) {}
    try {
      setupATCLoader();
    } catch (e) {}
    try {
      syncBundleSaveTitle();
    } catch (e) {}
  };

  let scheduled = false;
  const scheduleRun = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      runAll();
    });
  };

  let widgetObserver = null;
  const attachWidgetObserver = () => {
    if (widgetObserver) return true;
    const widget = document.querySelector('.picky-widget.picky-bundle-breaks');
    if (!widget) return false;
    widgetObserver = new MutationObserver(scheduleRun);
    widgetObserver.observe(widget, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['class', 'aria-disabled', 'disabled', 'style']
    });
    return true;
  };

  let variationObserver = null;
  const attachVariationObserver = () => {
    if (variationObserver) return;
    variationObserver = new MutationObserver(() => {
      if (bundleWidgetSuppressed()) scheduleRun();
    });
    variationObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class']
    });
  };

  let cartObserver = null;
  const attachCartObserver = () => {
    if (cartObserver) return true;
    const drawer = document.querySelector('slide-cart-drawer');
    if (!drawer) return false;
    cartObserver = new MutationObserver(scheduleCheckoutSync);
    cartObserver.observe(drawer, {
      subtree: true,
      childList: true,
      characterData: true
    });
    return true;
  };

  let oosObserver = null;
  const attachOosObserver = () => {
    if (oosObserver) return;
    const container =
      document.querySelector('.product__info-container') ||
      document.querySelector('.home-gym-pdp') ||
      document.body;
    if (!container) return;
    oosObserver = new MutationObserver(() => enforceOosHidden());
    oosObserver.observe(container, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['class', 'style']
    });
  };

  let visibilityScheduled = false;
  const scheduleVisibility = () => {
    if (visibilityScheduled) return;
    visibilityScheduled = true;
    requestAnimationFrame(() => {
      visibilityScheduled = false;
      updateStickyVisibility();
    });
  };

  setupCartInterceptor();
  setupSoloAddInterceptor();
  setupBundleBlockClickAnalytics();

  const init = () => {
    setupCartInterceptor();
    setupSoloAddInterceptor();
    setupBundleBlockClickAnalytics();
    runAll();
    updateStickyVisibility();

    if (!attachWidgetObserver()) {
      let attempts = 0;
      const waitForWidget = setInterval(() => {
        attempts += 1;
        runAll();
        if (attachWidgetObserver() || attempts >= 30) {
          clearInterval(waitForWidget);
        }
      }, 500);
    }

    attachVariationObserver();
    attachOosObserver();
    setInterval(() => {
      try {
        enforceOosHidden();
      } catch (e) {}
    }, 500);

    if (!attachCartObserver()) {
      let cartAttempts = 0;
      const waitForCart = setInterval(() => {
        cartAttempts += 1;
        if (attachCartObserver() || cartAttempts >= 30) {
          clearInterval(waitForCart);
        }
      }, 500);
    }

    window.addEventListener('scroll', scheduleVisibility, { passive: true });
    window.addEventListener('resize', scheduleVisibility);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
